import { BROADCAST_SET_ATTENDEE_TILE } from 'actions/Types';

const initialState = {};

export { initialState };

export default (state = initialState, action) => {
  if (action.type === BROADCAST_SET_ATTENDEE_TILE) {
    const { boundAttendeeId, tileId } = action.payload;
    return { ...state, [tileId]: boundAttendeeId };
  }

  return state;
};
